import systemConceptSlugs from '../constants/system-concept-slugs';

const SYSTEM_CONCEPT_SLUG = Object.values(systemConceptSlugs);

const isSystemConcept = (conceptSlug) => SYSTEM_CONCEPT_SLUG.includes(conceptSlug);

export default isSystemConcept;
